import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Map, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-10 px-4 relative overflow-hidden" data-id="element-112">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-113">
        <div className="inline-block bg-brand-accent text-white font-bold px-3 py-1 rounded-full mb-4 text-xs md:text-sm tracking-wider shadow-md" data-id="element-114">
          🌾 KIT PROFE™
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 leading-tight text-shadow-lg" data-id="element-115">
          Todo tu año de Historia Agraria.
          <br data-id="element-116" />
          <span className="text-brand-accent neon-glow" data-id="element-117">Listo. Desde hoy.</span>
        </h1>

        <div className="w-full max-w-sm md:max-w-lg mx-auto mb-6 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToCompra} data-id="element-118">
          <img src="https://cdn.magicpatterns.com/uploads/gi7iMuKJVi59pDhmAqvXuv/mockups_historia_agraria.png" alt="Kit Completo Historia Agraria Lista" className="w-full h-auto drop-shadow-2xl" data-id="element-119" />
        </div>

        <h2 className="text-base md:text-lg font-medium mb-4 max-w-2xl mx-auto text-brand-accent neon-glow" data-id="element-120">
          El sistema N°1 para docentes de Historia y Ciencias Sociales en
          escuelas secundarias rurales y técnicas de Argentina
        </h2>

        <p className="text-sm md:text-base mb-5 font-semibold text-gray-400" data-id="element-121">
          Tomos + evaluaciones + actividades listos para usar. Sin buscar. Sin
          armar. Sin perder domingos.
        </p>

        {/* All 4 badges in ONE line */}
        <div className="flex items-center justify-center gap-1.5 md:gap-3 mb-6 w-full" data-id="element-122">
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs whitespace-nowrap" data-id="element-123">
            <FileText className="w-3 h-3 mr-1 text-brand-accent shrink-0" data-id="element-124" />
            <span data-id="element-125">100% PDF</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs whitespace-nowrap" data-id="element-126">
            <Zap className="w-3 h-3 mr-1 text-brand-accent shrink-0" data-id="element-127" />
            <span data-id="element-128">5 min</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs whitespace-nowrap" data-id="element-129">
            <Map className="w-3 h-3 mr-1 text-brand-accent shrink-0" data-id="element-130" />
            <span data-id="element-131">Colonia→Hoy</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs whitespace-nowrap" data-id="element-132">
            <BookOpen className="w-3 h-3 mr-1 text-brand-accent shrink-0" data-id="element-133" />
            <span data-id="element-134">Básico+Orientado</span>
          </div>
        </div>

        <div className="w-full max-w-md mx-auto mb-4" data-id="element-135">
          <Button className="text-lg md:text-2xl py-3 md:py-4" data-id="element-136">
            🌾 → QUIERO MI KIT AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-500" data-id="element-137">
          <div className="flex items-center" data-id="element-138">
            <ShieldCheck className="w-4 h-4 mr-1 text-brand-accent" data-id="element-139" />
            <span data-id="element-140">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-141">
            <Lock className="w-4 h-4 mr-1 text-brand-accent" data-id="element-142" />
            <span data-id="element-143">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-144">
            <CreditCard className="w-4 h-4 mr-1 text-brand-accent" data-id="element-145" />
            <span data-id="element-146">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}